export const tr = {
    'amnesty-price': 'Gerçekleşen fiyat',
    'amnesty-price-with-currency': 'Gerçekleşen fiyat, {currency}',
    banners: 'Reklamlar',
    'campaign-group': 'Kampanya/Grup',
    'campaign-type': 'Kampanya türü',
    'context-price': 'Teklif (ağlarda)',
    'context-price-cpm': 'Bin gösterim başına teklif',
    'context-price-with-currency': 'Teklif (ağlarda), {currency}',
    'context-price-with-currency-cpm-banner': 'Bin gösterim başına teklif, {currency}',
    coverage: 'Kapsam',
    'coverage-with-percent': 'Kapsam, %',
    ectr: 'eCTR',
    phrase: 'Anahtar sözcük grupları',
    price: 'Teklif',
    'price-with-currency': 'Teklif, {currency}',
    priority: 'Öncelik',
    status: 'Durum',
    'traffic-forecast': 'Trafik tahmini'
};
